import { RouterService } from './../../../../../../services/router/router.service';
import { AlertService } from './../../../../../../services/alert/alert.service';
import { KpiService } from 'src/app/services/kpi/kpi.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';

@Component({
  selector: 'app-ranking',
  templateUrl: './ranking.page.html',
  styleUrls: ['./ranking.page.scss'],
})
export class RankingPage implements OnInit {
  categoryId
  IndicatorId
  typeRanking
  pageBack

  ranking
  /* image2 = `https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSEIEUfZcszO2S3zhclFkTO3NSjvCtqU2l2hRU6wsaHvrH26RrSxdkzjMNEqzxpu0gzOwQ&usqp=CAU` */
  constructor(public languageService: LanguagesService,
    private activatedRoute: ActivatedRoute,
    private kpiService: KpiService,
    private router: RouterService,
    private alertService : AlertService) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this.IndicatorId = params.idIndicator
      this.categoryId = params.idCategory
      this.typeRanking = params.typeRanking
      this.pageBack = `app/kpi/categories/${this.categoryId}/indicators/indicator/${this.IndicatorId}`
      this.getRanking(params.idIndicator);
    });
  }

  async getRanking(idKpi) {
    const indicators = await this.kpiService.getRankingKpi(idKpi,this.typeRanking)
    indicators.subscribe(async (data: any) => {

      let ranking = {...data}
      
      if(ranking.rankingUser){
        ranking.rankingUser.label = data.label ? data.label : ''
      }
      
     
      
      this.ranking = ranking
      if(!data.rankingUser && !data.listRankingUsers.length){
        this.alertService.presentAlert('No hay datos para este ranking')
        this.router.navigate(this.pageBack)
      }
    },err => {
      console.log('errr', err);
      
      if(err.error.code == 'RANKED_VAR_NOT_EXIST_IN_RANKING'){
        this.alertService.presentAlert('No hay datos para este tipo de ranking')
        this.router.navigate(this.pageBack)
      }
    })
  }

  get getTextsIUPageKpi() {
    return this.languageService.textsIU.page_kpi;
  }

}
